import { Minus, Plus, Check } from "lucide-react";
import { ADDONS } from "@/data/site";

export const emptyAddons = (addons = ADDONS) => addons.reduce((a, x) => ({ ...a, [x.key]: 0 }), {});
export const addonsTotal = (qty, addons = ADDONS) => addons.reduce((s, a) => s + (qty[a.key] || 0) * a.price, 0);
export const addonsSummary = (qty, addons = ADDONS) =>
  addons.filter((a) => (qty[a.key] || 0) > 0)
    .map((a) => (a.unit ? `${a.label} x${qty[a.key]}` : a.label))
    .join(", ");

export const AddonsPicker = ({ qty, setQty, addons = ADDONS }) => {
  const toggle = (k) => setQty({ ...qty, [k]: qty[k] ? 0 : 1 });
  const step = (k, d) => setQty({ ...qty, [k]: Math.max(0, (qty[k] || 0) + d) });

  return (
    <div className="space-y-2" data-testid="addons-picker">
      {addons.map((a) => {
        const isUnit = !!a.unit;
        const active = (qty[a.key] || 0) > 0;

        if (isUnit) {
          return (
            <div key={a.key} data-testid={`addon-row-${a.key}`}
              className={`flex items-center justify-between rounded-xl border px-4 py-2.5 transition-colors ${active ? "border-leaf bg-leaf/5" : "border-border bg-white"}`}>
              <div className="min-w-0 pr-3">
                <p className="text-sm font-medium text-navy">{a.label}</p>
                <p className="text-xs text-muted-foreground">${a.price} {a.unit}</p>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <button type="button" data-testid={`addon-${a.key}-minus`} onClick={() => step(a.key, -1)}
                  className="w-7 h-7 rounded-full border border-border flex items-center justify-center text-navy hover:bg-muted transition-colors"><Minus className="w-3.5 h-3.5" /></button>
                <span className="w-5 text-center text-sm font-semibold text-navy" data-testid={`addon-${a.key}-value`}>{qty[a.key] || 0}</span>
                <button type="button" data-testid={`addon-${a.key}-plus`} onClick={() => step(a.key, 1)}
                  className="w-7 h-7 rounded-full border border-border flex items-center justify-center text-navy hover:bg-muted transition-colors"><Plus className="w-3.5 h-3.5" /></button>
              </div>
            </div>
          );
        }

        return (
          <button key={a.key} type="button" role="checkbox" aria-checked={active} data-testid={`addon-${a.key}-toggle`} onClick={() => toggle(a.key)}
            className={`w-full flex items-center gap-3 rounded-xl border px-4 py-2.5 text-left transition-colors ${active ? "border-leaf bg-leaf/5" : "border-border bg-white hover:border-leaf/50"}`}>
            <span className={`w-5 h-5 rounded-md border-2 flex items-center justify-center shrink-0 transition-colors ${active ? "bg-leaf border-leaf" : "border-border bg-white"}`}>
              {active && <Check className="w-3.5 h-3.5 text-white" />}
            </span>
            <span className="min-w-0">
              <span className="block text-sm font-medium text-navy">{a.label}</span>
              <span className="block text-xs text-muted-foreground">${a.price}{a.note ? ` · ${a.note}` : ""}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
};
